import { createAction, props } from '@ngrx/store';

import {
  MatchResultsForUserResponse,
  GameHistorySearchParams,
} from '@fantaz/shared/data-access/models';

export const loadGameHistory = createAction(
  '[GameHistory Page] Init',
  props<{ params: GameHistorySearchParams }>(),
);

export const loadGameHistorySuccess = createAction(
  '[GameHistory/API] Load GameHistory Success',
  props<{ gameHistory: MatchResultsForUserResponse }>(),
);

export const loadGameHistoryFailure = createAction(
  '[GameHistory/API] Load GameHistory Failure',
  props<{ error: any }>(),
);

export const clearGameHistory = createAction(
  '[GameHistory/API] Clear GameHistory',
);
